


























































































































import { defineComponent, computed, watch, ref, PropType } from '@vue/composition-api';
// components
import avatar from '@/components/avatar/index.vue';
import navLink from '../header/navigation/nav-link.vue';
import subList from '../header/navigation/sub-list.vue';
// user
import { useBroadcast } from '@/common/utils';
import { CurrentUserModel } from '@/models/current-user';
import { useApolloModel } from 'vue-apollo-model';
import { LoginSource } from '@/common/const';
import ConfigModel from '@/models/config';
// conf
import { NAVUSER_LIST } from './config';
import { useLog } from '@/common/log';
import { filterXss } from '@/common/util/parseText';

export default defineComponent({
    components: {
        avatar,
        navLink,
        subList,
    },
    filters: {
        filterXss,
    },
    props: {
        loginButtonUiData: {
            type: Object as PropType<{background: string; color: string;}>,
        },
    },
    setup() {
        const broadcast = useBroadcast();
        const currentUserModel = useApolloModel(CurrentUserModel);
        const configModel = useApolloModel(ConfigModel);
        const log = useLog();
        const isLogin = computed(() => {
            return !!currentUserModel.userInfo.id;
        });
        const profileLink = ref('');
        function login() {
            log({
                type: 'CLICK',
                event_name: 'TOP_TAB_BUTTON',
                event_value: {
                    icon: '登录按钮',
                },
            });
            broadcast('login', {
            // 登录源，供日志上报使用
                source: LoginSource.TOP_LOGIN,
            });
        }
        function logout() {
            currentUserModel.logout();
            broadcast('logout', {
                position: 'abc',
            });
        }
        function switchUser() {
            broadcast('login', {
            // 登录源，供日志上报使用
                source: LoginSource.TOP_LOGIN,
            });
        }
        watch(() => currentUserModel.userInfo.eid, val => {
            if (val) {
                profileLink.value = `/profile/${val}`;
            }
        }, {
            immediate: true,
        });
        const NAVUSER_LIST_CUR = computed(() => {
            return NAVUSER_LIST.filter(item => {
                return configModel.hasPermission(item.role);
            });
        });
        return {
            NAVUSER_LIST_CUR,
            isLogin,
            login,
            logout,
            currentUserModel,
            log,
            profileLink,
            switchUser,
        };
    },
});

